import { render, staticRenderFns } from "./VeterinarianList.vue?vue&type=template&id=56133fa7&scoped=true&"
import script from "./VeterinarianList.vue?vue&type=script&lang=js&"
export * from "./VeterinarianList.vue?vue&type=script&lang=js&"
import style0 from "./VeterinarianList.vue?vue&type=style&index=0&id=56133fa7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56133fa7",
  null
  
)

export default component.exports